import { render, staticRenderFns } from "./openPlugin.vue?vue&type=template&id=8bc0be36"
import script from "./openPlugin.vue?vue&type=script&lang=js"
export * from "./openPlugin.vue?vue&type=script&lang=js"
import style0 from "./openPlugin.vue?vue&type=style&index=0&id=8bc0be36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports